import { ICellRenderer } from '@ag-grid-enterprise/all-modules';

import TaxeModel from '../model/Taxe';
import TaxesService from '../services/TaxesService';

class TaxeCellRenderer implements ICellRenderer {
	private eGui: HTMLElement;
	private value: string;

	private taxesService: TaxesService;

	constructor() {
		this.eGui = document.createElement('div');
		this.eGui.innerHTML = '';

		this.taxesService = new TaxesService();
		this.value = '';
	}

	public init(params: any) {
		this.value = params.value;

		if (this.value) {
			this.taxesService.getById(this.value).then((data) => {
				if (data) {
					this.eGui.innerHTML = new TaxeModel(data).displayAggrid();
					this.eGui.title = data.label;
				} else {
					this.eGui.innerHTML = '-';
				}
			}).catch(() => {
				this.eGui.innerHTML = '-';
			});
		} else {
			this.eGui.innerHTML = '-';
		}
	}

	public getGui() {
		return this.eGui;
	}

	public refresh() {
		return false;
	}
}

export default TaxeCellRenderer;
